// nb: this enum is used in deck creation filter
// deprecated todo remove
export enum Tag {
  /* HERO = "champion",
  HERO_CARD = "championCard", */
  CHAMPION = "hero",
  CHAMPION_CARD = "heroCard",
  SPIDERMAN = "spiderMan",
  CAPTAIN_MARVEL = "captainMarvel",
  SHE_HULK = "sheHulk",
  IRON_MAN = "ironMan",
  BLACK_PANTHER = "blackPanther",
  CAPTAIN_AMERICA = "captainAmerica",
  MS_MARVEL = "msMarvel",
  THOR = "thor",
  BLACK_WIDOW = "blackWidow",
  DOCTOR_STRANGE = "doctorStrange",
  ALLY = "ally",
  EVENT = "event",
  SUPPORT = "support",
  UPGRADE = "upgrade",
  RESOURCE = "resource",
  AGGRESSION = "aggression",
  JUSTICE = "justice",
  LEADERSHIP = "leadership",
  PROTECTION = "protection",
  BASIC = "basic",
  INVOCATION = "invocation",
  HULK = "hulk"
}

export enum CardMarvelTag {
  CHAMPION = "HERO",
  CHAMPION_CARD = "HERO_CARD",
  SPIDERMAN = "SPIDERMAN",
  CAPTAIN_MARVEL = "CAPTAIN_MARVEL",
  SHE_HULK = "SHE_HULK",
  IRON_MAN = "IRON_MAN",
  BLACK_PANTHER = "BLACK_PANTHER",
  CAPTAIN_AMERICA = "CAPTAIN_AMERICA",
  MS_MARVEL = "MS_MARVEL",
  THOR = "THOR",
  BLACK_WIDOW = "BLACK_WIDOW",
  DOCTOR_STRANGE = "DOCTOR_STRANGE",
  ALLY = "ALLY",
  EVENT = "EVENT",
  SUPPORT = "SUPPORT",
  UPGRADE = "UPGRADE",
  RESOURCE = "RESOURCE",
  AGGRESSION = "AGGRESSION",
  JUSTICE = "JUSTICE",
  LEADERSHIP = "LEADERSHIP",
  PROTECTION = "PROTECTION",
  BASIC = "BASIC",
  INVOCATION = "INVOCATION",
  HULK = "HULK"
}
